import { createTheme } from '@mui/material/styles';

const ENV_COLORS = {
  production:  { primary: '#953EF1', secondary: '#7B32C7' },
  development: { primary: '#E65100', secondary: '#BF360C' },
};

export function createAppTheme(mode = 'light', env = 'production') {
  const colors = ENV_COLORS[env] || ENV_COLORS.production;
  return createTheme({
    palette: {
      mode,
      primary: { main: colors.primary },
      secondary: { main: colors.secondary },
    },
    shape: {
      borderRadius: 12,
    },
    typography: {
      fontFamily: [
        'Roboto',
        '-apple-system',
        'BlinkMacSystemFont',
        'Segoe UI',
        'Helvetica',
        'Arial',
        'sans-serif',
        'Apple Color Emoji',
        'Segoe UI Emoji',
      ].join(','),
      h1: { fontWeight: 700 },
      h2: { fontWeight: 700 },
      h3: { fontWeight: 700 },
      h4: { fontWeight: 700 },
      h5: { fontWeight: 700 },
      h6: { fontWeight: 700 },
    },
    components: {
      MuiPaper: {
        styleOverrides: {
          root: {
            borderRadius: 12,
          },
        },
        defaultProps: {
          elevation: 2,
        },
      },
      MuiButton: {
        defaultProps: {
          size: 'medium',
        },
        styleOverrides: {
          root: {
            fontWeight: 700,
            transition: 'transform 120ms ease, box-shadow 120ms ease',
            '&:hover': {
              transform: 'translateY(-1px)',
            },
          },
          containedPrimary: {
            backgroundColor: colors.primary,
            '&:hover': { backgroundColor: colors.secondary },
          },
        },
      },
      MuiTableCell: {
        styleOverrides: {
          root: {
            paddingTop: 8,
            paddingBottom: 8,
          },
        },
      },
      MuiChip: {
        defaultProps: {
          size: 'small',
        },
      },
    },
  });
}

// Default export a light theme for modules that import directly
const defaultTheme = createAppTheme('light');
export default defaultTheme;
